import { z } from 'zod';
import { AuditMeta, DocId, IsoTimestamp, TenantId } from '../common.js';
/**
 * Wijzigingsverzoek (change request) — replaces the "email Andre" workflow.
 *
 * Firestore path: change_requests/{reqId}
 * Kept at root (not tenant-subcollection) because kb_admin reviews
 * cross-tenant requests in one queue.
 */
export const ChangeRequestType = z.enum(['kennisbank_aanvulling', 'fout_melden', 'overig']);
export const ChangeRequestStatus = z.enum([
    'new',
    'in_progress',
    'info_requested',
    'approved',
    'rejected',
]);
export const ChangeRequestSchema = AuditMeta.extend({
    id: DocId,
    tenantId: TenantId,
    submittedByUserId: DocId,
    type: ChangeRequestType,
    title: z.string().min(1).max(200),
    description: z.string().min(1).max(5000),
    /**
     * For kennisbank_aanvulling originating from a refuse-to-answer event,
     * the query text that failed retrieval. Powers the content-improvement loop.
     */
    originatingQuery: z.string().max(2000).optional(),
    /**
     * Cloud Storage paths of uploaded attachments.
     */
    attachmentUris: z.array(z.string().url()).default([]),
    status: ChangeRequestStatus.default('new'),
    /**
     * Populated on status transitions.
     */
    reviewedByUserId: DocId.optional(),
    reviewedAt: IsoTimestamp.optional(),
    reviewerNote: z.string().max(2000).optional(),
});
/**
 * Submission payload. Tenant + user injected by the route.
 */
export const SubmitChangeRequestInput = z.object({
    type: ChangeRequestType,
    title: z.string().min(1).max(200),
    description: z.string().min(1).max(5000),
    originatingQuery: z.string().max(2000).optional(),
    attachmentUris: z.array(z.string().url()).max(5).optional(),
});
/**
 * Admin review action payload. Status transitions are validated at service layer.
 */
export const ReviewChangeRequestInput = z.object({
    action: z.enum(['approve', 'reject', 'request_info']),
    reviewerNote: z.string().max(2000).optional(),
});
//# sourceMappingURL=change-request.js.map